<template>
  <div class="custom-form-preview">
    <div class="preview-phone">
      <div class="preview-phone-box" @dragover="event => event.preventDefault()" @drop="event => handleDrop(event)">
        <div class="form-flow-name">
          <span>{{ title || $t('07428016') }}</span>
        </div>
        <div class="custom-form-box">
          <!-- 无组件 -->
          <div class="no-control" v-if="!formItems.length">
            <div class="no-control-box">
              <img src="../img/no-control.png" alt="no data" />
              <p>{{ $t('i18n.c049e632bd73411f9069dac310e0481b') }}</p>
            </div>
          </div>
          <div
            v-for="(item, index) in formItems"
            class="custom-form-item-box"
            :key="item.id"
            draggable="true"
            @dragstart="event => handleDragStart(event, index)"
            @dragover="event => handleOver(event, item.id)"
            @dragend="event => handleDragend(event, index)"
            @drop.stop="event => handleItemDrop(event, index)"
            :class="{
              'com-active': item.id === currentCom,
              'com-over': item.id === currentOver,
              'border-hide': item.type === 3,
              'error-valid': !item.rule
            }"
            @click="handleClick(item)"
          >
            <component :is="comEnum.get(item.type)" :require="item.attribute.require" :form="item.attribute">
              {{ item.attribute.name }}
            </component>
            <transition name="fade" leave-active-class="leave">
              <span class="el-icon-close" v-if="item.id === currentCom" @click="handleDel(index)"></span>
            </transition>
          </div>
        </div>
        <!-- <button @click="handlClick">ceshi</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { comEnum, componentBaseData } from '../enum'
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    formItems: {
      default: () => []
    },
    title: {
      default: ''
    }
  },
  data() {
    return {
      // 组件列表
      comEnum,
      // 当前选中ID
      currentCom: '',
      // 目标元素ID
      currentOver: ''
      // formItems: []
    }
  },
  mounted() {
    // 初始化默认选中第一项
    setTimeout(() => {
      const item = this.formItems[0]
      this.currentCom = item.id
      this.$emit('active', item)
      this.$emit('changeViewCtrl', true)
    })
  },
  methods: {
    // handlClick() {
    //   // console.log(JSON.stringify(this.formItems))
    // },
    // 拖放结束添加
    handleDrop(event) {
      event.stopPropagation()
      const type = +event.dataTransfer.getData('type')
      if (!type) return false
      this.currentCom = uuidv4() //  Date.now() + Math.random()
      const item = {
        id: this.currentCom,
        type,
        rule: true,
        attribute: componentBaseData.get(type)()
      }
      this.formItems.push(item)
      this.$emit('active', item)
      this.$emit('changeViewCtrl', true)
      this.currentOver = ''
    },
    // 组件内拖拽开始
    handleDragStart(event, index) {
      event.dataTransfer.setData('index', index)
    },
    // 拖拽过程
    handleOver(event, id) {
      this.currentOver = id
    },
    handleDragend() {
      this.currentOver = ''
    },
    // 拖拽结束
    handleItemDrop(event, index) {
      event.stopPropagation()
      // 清空悬浮样式
      this.currentOver = ''
      // 首先获取将要换位的组件
      // 注意这里paramIndex值可能为0
      const paramIndex = event.dataTransfer.getData('index')
      const type = +event.dataTransfer.getData('type')
      let item
      // 这里区分插入或者换位
      if (paramIndex) {
        item = this.formItems.splice(paramIndex, 1)[0]
        this.formItems.splice(index, 0, item)
      }
      if (type) {
        item = {
          id: uuidv4(),
          type,
          rule: true,
          attribute: componentBaseData.get(type)()
        }
        this.formItems.splice(index, 0, item)
      }
      // 展示属性详情
      this.currentCom = item.id
      this.$emit('active', item)
      this.$emit('changeViewCtrl', true)
    },
    // 当前组件ID
    handleClick(item) {
      this.currentCom = item.id
      this.$emit('active', item)
    },
    // 删除组件
    handleDel(index) {
      this.formItems.splice(index, 1)
    }
  }
}
</script>
